import { useState, useCallback } from 'react';

import { STEP_BACK_MAP } from '../constants';
import { type EkycStep } from '../types';

export function useEKycNavigation(initialStep: EkycStep = 'onboarding') {
  const [step, setStep] = useState<EkycStep>(initialStep);

  const goBackToPreviousStep = useCallback(() => {
    const previousStep = STEP_BACK_MAP[step];
    if (previousStep) {
      setStep(previousStep);
    }
  }, [step]);

  const goToStep = useCallback((newStep: EkycStep) => {
    setStep(newStep);
  }, []);

  return {
    step,
    setStep: goToStep,
    goBackToPreviousStep,
  };
}
